import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible/index.js'
import { Toast, Dialog ,Skeleton } from 'vant';
createApp(App).use(router).mount('#app')
createApp(App).use(Toast)
createApp(App).use(Dialog)
createApp(App).use(Skeleton)
